import {React, Component, Container} from 'utils';
import {Creators, StandStore} from 'model';
import {Filters, SearchFilter} from 'components';

class StandSearch extends Component {

	static getStores()
	{
		return [StandStore];
	}

	static calculateState()
	{
		return {
			query: StandStore.getQuery(),
			filters: [
				// {name: 'activities', items: StandStore.getState().filters.activities},
				// {name: 'companies', items: StandStore.getState().filters.companies}
			]
		}
	}

	handleChange = (event) =>
	{
		let value = $(event.target).val();
		Creators.standSearchQueryChanged(value);
	};

	filterClick = (event) =>
	{
		let filter = $(event.target).data('filter');
		let name = $(event.target).data('name');
		let index = $(event.target).data('index');
		Creators.standsFilterItemClicked(filter, name, index);
	};

	removeFilterClick = (event) =>
	{
		let filter = $(event.target).data('filter');
		let name = $(event.target).data('name');
		let index = $(event.target).data('index');
		Creators.standsFilterItemRemoveClicked(filter, name, index);
	};

	applyFiltersClick = (event) =>
	{
		Creators.standsApplyFilters();
		let name = $(event.target).data('hide-function-name');
		Creators.closeFilterModal(name);

		Creators.standsApplyFilters();
		Creators.hideFilterModal('stands');
	};

	render()
	{
		const {query, filters} = this.state;

		return <div className="standsearch">
			<Filters filters={filters} page="stands"
					 query={query}
					 loading={false}
					 handleChange={this.handleChange}
					 onFilterClick={this.filterClick}
					 onOkClick={this.applyFiltersClick}
					 onTagClick={this.removeFilterClick}
			/>
		</div>
	}
}

export default Container.create(StandSearch);


// WEBPACK FOOTER //
// ./src/modules/components/standsearch.js